<template>
    <div class="cmpnt-box page">
        <!-- <div class="lmy-map-back lmy-back-long" @click="backToLastPage" >
          <i class="iconfont icon-back" >	</i>
          <label>返回</label>
        </div> -->
        <div class="go-back">
            <i class="iconfont icon-close"  @click="backToLastPage">	</i>
        </div>
        <div class="meetSubTop">
            <div class="main">
                <p><img src="./../../../assets/img/success.png" alt=""></p>
                <p class="text">需求提交成功</p>
                <p class="seeOrder" @click="checkOrder">查看订单</p>
            </div>
        </div>
        <div class="meetSubBottom">
            <dl>
                <dt>
                    <img src="./../../../assets/img/success.png" alt="">
                </dt>
                <dd>
                    <p>需求提交成功</p>
                    <p class="tip">您的会议需求已开始处理</p>
                </dd>
            </dl>
            <dl>
                <dt>
                    <img src="./../../../assets/img/success.png" alt="">
                </dt>
                <dd>
                    <p>正在为您安排会议顾问</p>
                    <p class="tip">正在为您安排1对1的专属会议顾问</p>
                </dd>
            </dl>
            <dl>
                <dt></dt>
                <dd>
                    <p>顾问致电，与您确认需求</p>
                    <p class="tip">会议顾问将在分配完后10分钟左右致电您</p>
                </dd>
            </dl>
            <dl>
                <dt></dt>
                <dd>
                    <p>获取场地方案（包含档期报价）</p>
                    <p class="tip">会议顾问将为您严选3-6个场地</p>
                </dd>
            </dl>
            <dl>
                <dt></dt>
                <dd>
                    <p>确认会议场地</p>
                    <p class="tip">您确定方案后，直接和场地签约预订</p>
                </dd>
            </dl>
            <dl>
                <dt></dt>
                <dd>
                    <p>会议举办</p>
                    <p class="tip">在场地举办活动，有问题可随时联系顾问解决</p>
                </dd>
            </dl>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            list:[]
        }
    },
    created(){
        this.initData()
    },
    methods:{
        initData(){
            var that = this
            
            var params={
                Page:1,
                PageSize:10
            }
            this.postRequest({
                url: this.Api.MeetingSearch,
                params: params
            }).then(res => {
                if (res&&res.IsSuccess) {
                    that.list = res.Result
                }
            });
        },
        backToLastPage(){
            this.$emit("modifyShowSubmitPage",false)
        },
        checkOrder(){
            this.$router.push('/meetingDetails?id='+this.list[0].MettingID)
        },
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/usr/meeting/submitPage.vue